export default "__VITE_PUBLIC_ASSET__1e71c8bf__"